import { render, staticRenderFns } from "./Recuentos.vue?vue&type=template&id=5ca4e7b4"
import script from "./Recuentos.vue?vue&type=script&lang=js"
export * from "./Recuentos.vue?vue&type=script&lang=js"
import style0 from "./Recuentos.vue?vue&type=style&index=0&id=5ca4e7b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports